/* eslint-disable no-nested-ternary */
import React, { useState, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery, useMutation } from 'react-query';
import { useDropzone } from 'react-dropzone';
import Select from 'react-select';
import AsyncSelect from 'react-select/async';
import styled from 'styled-components';
import { ProgressBar, Step } from 'react-step-progress-bar'
import { useForm, Controller } from 'react-hook-form';
import produce from 'immer'
import { Button, Progress, CustomInput } from 'reactstrap';

import { fetcher } from 'api/client';
import { fetchTemplates } from 'api/actions/templates';
import useTemplateAction from 'api/hooks/templates/useTemplateAction';
import { getParsedContractTypes } from 'api/actions/contracts';

import useReferenceComponent from 'hooks/useReferenceComponent';

import { NextBtn, BackBtn } from 'components/Shared/Button';
import { reactSelectStyles } from 'components/Shared/ReactSelectStyles'
import DragZone from 'components/Shared/DragZone';

import { StepContainer } from './StepContainer';
import ReferenceDocument from '../ReferenceDocument';
import { fileTypes, contractStatusOptions } from '../Constants/types';
import useFileUpload from 'api/hooks/file/useFileUpload';
import { bulkCreate } from 'api/actions/contracts';
import useDebounce from 'hooks/useDebounce';
import { getMongoObjectId, downloadFile } from 'utils';
import { VariablesMenu } from 'components/Editor/Canvas/TratoFormat';

const StyledStep = styled(Step)`
  color: white;
  width: 20px;
  height: 20px;
  font-size: 12px;
  background-color: rgba(211, 211, 211, 0.8);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  &.accomplished {
    background-color: rgba(0, 116, 217, 1);
  }
`

function Stepper({
   steps = [],
   currentStep
}) {
  const length = steps.length;
  const percentPerStep = 100/(length - 1);

  return (
    <ProgressBar height={5} filledBackground="#f47b33" percent={Math.min(percentPerStep * (currentStep - 1) + 1, 100)} hasStepZero>
    {
      steps.map((step) => (
        <StyledStep>
        {({ accomplished, index }) => (
          <div
            className={`indexedStep position-relative ${accomplished ? "accomplished pointer" : null}`}
            onClick={currentStep > index + 1 ? step.onClick : undefined}
          >
            {currentStep > index + 1 ?  <i className="fa fa-check-circle" /> : index + 1}
            <div className="position-absolute text-black-50 text-center" style={{top: 40}}>{step.title}</div>
          </div>
        )}
      </StyledStep>
      ))
    }
  </ProgressBar>
  )
}

const MultipleStep = ({ handleBack, onComplete, showReference }) => {
    const { t } = useTranslation();
    const [files, setFiles] = useState([]);
    const [filesProgress, setFilesProgress] = useState({})
    const [currentLayout, setCurrentLayout] = useState({});
    const [currentStep, setCurrentStep] = useState(1);
    const [skipLayoutConfiguration, setSkipLayoutConfiguration] = useState(false);
    const [uploadStatus, setUploadStatus] = useState('draft');
    const [nextStep, setNextStep] = useState(false);
    const [reference, handleRefChange] = useReferenceComponent();
    const [error, setError] = useState(null);


    const steps = useMemo(() => {
        return [
          {
            title: t('Carga Documentos'),
            key: 'generalData',
            onClick: () => {  },
            Component: UploadDocuments,
          },
          {
            title: t('Carga Plantilla'),
            key: 'personalData',
            onClick: () => { },
            Component: UploadLayout
          },
          {
            title: t('Configuracion'),
            key: 'attachments',
            onClick:() => { },
            Component: UploadConfiguration
          },
        ]
      }, [t])

      const currentSelectedStep = steps[currentStep - 1];
      const isLast = currentStep === steps.length;

    const handleNext = () => {

        if (currentStep === 1 && !files.length) {
            //se debe elegir al mejos un archivo    
            return;
        }
        if (currentStep === 2 && !currentLayout.name) {
            //se debe elegir un archivo
            return;
        }
    
        if (skipLayoutConfiguration && currentStep === 1) {
            setCurrentStep(3)
            setCurrentLayout({})
        } else {
            setCurrentStep(step => Math.min(step + 1, steps.length))
        }
        
    };

    const handleSubmit = () => {
        if (reference.join && reference.documentMissing) {
            return;
        }

        onComplete({ files, uploadStatus, layout: currentLayout, skipLayoutConfiguration }, reference);
        
    }

    const handleBackBtn = () => {
        if (skipLayoutConfiguration && currentStep === 3) {
            setCurrentStep(1)
        } else if (currentStep === 1) {
            handleBack();
            setFiles([]);
            setCurrentLayout({})
        } else {
           setCurrentStep(step => Math.max(step - 1, 1))
        }
    };

    return (
        <StepContainer
            className="sidebar-new-contract-height"
            // title={t('contracts.new.source_file_multiple')}
            form={
                <div className="py-3">
                    <div className="mx-auto" style={{width: 300, marginBottom: 60}}>
                        <Stepper steps={steps} currentStep={currentStep} />
                    </div>
                    <div className="">
                        <currentSelectedStep.Component 
                            step={currentSelectedStep}
                            files={files}
                            currentLayout={currentLayout}
                            uploadStatus={uploadStatus}
                            filesProgress={filesProgress}
                            skipLayoutConfiguration={skipLayoutConfiguration}
                            setFiles={setFiles}
                            setFilesProgress={setFilesProgress}
                            setCurrentLayout={setCurrentLayout}
                            setUploadStatus={setUploadStatus}
                        />
                    </div>
                
                </div>
            }
            footer={
                <>
                    <CustomInput 
                        hidden={currentStep !== 1}
                        className="mb-2"
                        type="switch"
                        name="skipLayoutConfiguration"
                        id="skipLayoutConfiguration"
                        label="Hacer opcional la configuración"
                        checked={skipLayoutConfiguration}
                        onChange={(evt) => {
                            console.log({skipLayoutConfiguration, s: evt.target.checked})
                            setSkipLayoutConfiguration(evt.target.checked)
                        }}
                    />
                    <BackBtn onClick={handleBackBtn} label={t('form.exit')} />
                    <NextBtn onClick={isLast ? handleSubmit : handleNext} label={isLast ? 'Cargar' : t('contracts.listing.page_next')} />
                </>
            }
        />
    );
};

export default MultipleStep;

const HorizontalRule = styled.div`
    display: block;
    text-align: center;
    overflow: hidden;
    white-space: nowrap; 
    > span {
        position: relative;
        display: inline-block;
    }
	
    > span:before,
    > span:after {
        content: "";
        position: absolute;
        top: 50%;
        width: 9999px;
        height: 1px;
        background: black;
    }

    > span:before {
        right: 100%;
        margin-right: 15px;
    }

    > span:after {
        left: 100%;
        margin-left: 15px;
    }
`
const HorizontalRuleText = styled.span`
`

function UploadDocuments({ files, setFiles, filesProgress, setFilesProgress }) {
    const { t } = useTranslation();
    const [templateToDownload, setTemplateToDownload] = useState({})
    const { uploadFile } = useFileUpload({
        onUploadProgress: (evt, body) => {
            setFilesProgress(produce(draft => {
                draft[body._id] = evt;
            }))
        },
        onSuccess: (data, variables) => {
            setFiles(produce(draft => {
               const index = draft.findIndex(f => f._id === variables._id);
               if (index > -1) {
                   draft[index].url = data.url;
                   draft[index].uploadResult = data;
               }
               console.log({index, data, variables, dw: draft[index].url})
            }))
        }
    })
    const {  mutate: mutateDownloadLayout } = useTemplateAction(templateToDownload.value)


    const handleDrop = (files) => {
        console.log({files})
        setFiles(produce(draft => {
            files.map(file => {
                const fileToUpload = {
                    file,
                    _id: getMongoObjectId()
                }
                draft.push(fileToUpload)
                uploadFile(fileToUpload)
            })
        }))
    }

    const handleDropRejected = (rejected) => {
        console.log({rejected})
    }
    
    const handleRemoveFile = ({ id }) => {
        setFiles(file => files.filter(f => f._id !== id))
    }

    const handleTemplateChange = (option) => {
        // setFiles({})
        // setFilesProgress({})
        setTemplateToDownload(option)
    }

    const handleExportTemplateExcel = () => {
        console.log({templateToDownload})
        mutateDownloadLayout({ action: 'massive', config: { responseType: 'blob' } }, {
            onSuccess: (data) => {
              downloadFile({
                name: `${templateToDownload.label}`,
                blob: new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }),
                ext: 'xlsx'
              })();
            }
          });
    }

    const loadTemplates = async (search) => {
        const { docs } = await fetcher(
            fetchTemplates({
                templatesOnly: true,
                search: search && `name|${search}`,
               })
        );
        return docs.map((template) => ({
            label: template.name,
            value: template.id,
            template,
        }));
    };

    console.log({ files, filesProgress })

    return (
        <div>
            <h3 className="mt-3 p-2">
                Sube tus documentos PDF
            </h3>
            <div>
                <div style={{maxHeight: 200, overflow: 'auto'}}>
                    {files.map(file => (
                        <FileItem 
                            name={file?.file?.name} 
                            id={file._id}
                            currentSize={filesProgress[file._id]?.loaded || 0} 
                            totalSize={filesProgress[file._id]?.total || file.size} 
                            onRemove={handleRemoveFile}
                        /> 
                    ))}
                </div>
                <DragZone
                    // imgSrc="/images/listing/createDocument/subir.svg"
                    icon="cloud-upload-alt"
                    label={t('common.drag_file_2')}
                    className=""
                    version={2}
                    maxFiles={20}
                    isDisabled
                    acceptedFiles={['.pdf']}
                    multiple={true} 
                    onDrop={handleDrop}
                    onDropRejected={handleDropRejected}
                />      
            </div>
            <HorizontalRule className="mt-2">
                <HorizontalRuleText>
                    O
                </HorizontalRuleText>
            </HorizontalRule>
            <div className="mt-2">
                <h5 className="font-weight-bold">
                    Descarga un Layout de una Plantilla Excel
                </h5>
                <div className="mt-3">
                    Elige Plantilla
                </div>
                <div className="d-flex justify-content-between mt-3">
                    <AsyncSelect
                        styles={{
                            menu: (provided) => ({ ...provided, zIndex: 3000 }),
                        }}
                        inputId="create-template-select"
                        id="create-template-select" 
                        name="template"
                        className="create-select w-100 mr-1"
                        defaultOptions
                        cacheOptions={true}
                        loadOptions={loadTemplates}
                        onChange={handleTemplateChange}
                        placeholder={t('contracts.new.template_choose')}
                        noOptionsMessage={() => {
                            return <div>{t('common.no_templates')}</div>;
                        }}
                    />
                    <Button color="primary" onClick={handleExportTemplateExcel}> Descargar </Button>
                </div>
            </div>
        </div>
    )
}

function UploadLayout({ currentLayout, setCurrentLayout, filesProgress, setFilesProgress }) {
    const { t } = useTranslation();
    const { uploadFile } = useFileUpload({
        onUploadProgress: (evt) => {
            console.log({evt})
            setFilesProgress(p => ({
                ...p,
                layout: evt 
            }))
        },
        onSuccess: (data) => {
            setCurrentLayout(produce(draft => {
                draft.url = data.url;
            }))
        }
    })

    const handleDrop = (files) => {
        console.log({files})
        
        if (files?.[0]) {
            setCurrentLayout(files[0])
            uploadFile({
                file: files[0]
            })
        }
    }

    const handleDropRejected = (rejected) => {
        console.log({rejected})
    }
    
    const handleRemoveFile = ({ id }) => {
        setCurrentLayout({})
        setFilesProgress(p => ({
            ...p,
            layout: {} 
        }))
    }

    return (
        <div>
            <h3 className="mt-3 p-2">
                Carga Layout
            </h3>            
            { currentLayout.name ?
                <FileItem 
                    name={currentLayout.name} 
                    currentSize={filesProgress.layout?.loaded || 0} 
                    totalSize={filesProgress.layout?.total || currentLayout.size} 
                    onRemove={handleRemoveFile}
                /> 
                :
                <DragZone
                    // imgSrc="/images/listing/createDocument/subir.svg"
                    icon="cloud-upload-alt"
                    label={t('common.drag_file_2')}
                    className=""
                    version={2}
                    acceptedFiles={['.xlsx', '.xls']}
                    multiple={true} 
                    onDrop={handleDrop}
                    onDropRejected={handleDropRejected}
                />
            }
        </div>
    )
}

function UploadConfiguration({ files, currentLayout, uploadStatus, skipLayoutConfiguration, setUploadStatus }) {
    const handleChange = (evt) => {
        console.log({evt: evt.target.id })
        setUploadStatus(evt.target.id)
    }

    return (
        <div>
            <div>
                <div className="font-weight-bold">Subir como</div>
                <CustomInput 
                    className="ml-2"
                    label="Borrador"
                    type="radio"
                    id="draft"
                    onChange={handleChange}
                    checked={uploadStatus === 'draft'}
                />
                <CustomInput 
                    className="ml-2"
                    label="Enviar"
                    type="radio"
                    id="send"
                    onChange={handleChange}
                    hidden={skipLayoutConfiguration}
                    checked={uploadStatus === 'send'}
                />
                <CustomInput 
                    className="ml-2"
                    label="Firma fisica"
                    type="radio"
                    id="physical-signature"
                    onChange={handleChange}
                    checked={uploadStatus === 'physical-signature'}
                />
            </div>
            <div className="font-weight-bold my-2">
                Documentos
            </div>
            <div className="border">
                {
                    files.map(file => (
                        <FileItem key={file._id} name={file?.file?.name} _id={file._id} simple />
                    ))
                }
            </div>
            <div className="font-weight-bold my-2" hidden={skipLayoutConfiguration}>
                Plantilla
            </div>
            <div className="border" hidden={skipLayoutConfiguration}>
                <FileItem key={currentLayout} name={currentLayout?.name} simple />
            </div>
            
        </div>
    )
}

function FileItem ({
    id,
    name,
    currentSize, 
    totalSize,
    error,
    simple = false,
    onRemove
}) {
    const isUploaded = useMemo(() => currentSize === totalSize, [currentSize, totalSize]);
    const debounceisUploaded = useDebounce(isUploaded, 500)

    const handleRemove = () => {
        onRemove?.({id})
    }

    return (
        <div className="p-4 position-relative">
            <i className="fas fa-times text-danger position-absolute right-0 mr-2"  hidden={simple || !debounceisUploaded} onClick={handleRemove} />
            <div className="d-flex justify-content-between align-items-center">
                <span>
                    <i className="fas fa-file text-muted mr-2" />
                    {name}
                </span>
                <span hidden={simple}>
                    {debounceisUploaded  ? 
                        <i className="fas fa-check-circle text-primary ml-2" />
                    : error  ? 
                        <span>{error} <i className="fas fa-times-circle text-danger ml-2" /></span>
                    : <span className="ml-2" >{currentSize} de {totalSize}</span>}
                </span>
            </div>
            <Progress
                hidden={simple}
                color="primary"
                value={currentSize/totalSize * 100}
            />
        </div>
    )
}
